// import moment from 'moment';
import _ from "lodash";

// const getSalePriceByYear = (year, history) => {
//   const record = _.find(history, record => record.time === year);
//   return _.get(record, 'salePrice', 0);
// }
// const getCapitalGainFromTo = (from, to) => {
//   return (from - to) / to;
// }

// export const calcProjectCapitalGain = project => {
//   const { history, current } = project;
//   const { salePrice: priceToday } = current;

//   const today = moment();
//   const last1Y = today.clone().subtract(1, 'years').format('YYYY');
//   const last3Y = today.clone().subtract(3, 'years').format('YYYY');
//   const last5Y = today.clone().subtract(5, 'years').format('YYYY');
//   // console.log('last1Y', last1Y);
//   // console.log('last3Y', last3Y);
//   // console.log('last5Y', last5Y);

//   const priceLast1Y = getSalePriceByYear(last1Y, history);
//   const priceLast3Y = getSalePriceByYear(last3Y, history);
//   const priceLast5Y = getSalePriceByYear(last5Y, history);
//   // console.log('priceLast1Y', priceLast1Y);
//   // console.log('priceLast3Y', priceLast3Y);
//   // console.log('priceLast5Y', priceLast5Y);

//   const cap1Y = getCapitalGainFromTo(priceToday, priceLast1Y);
//   const cap3Y = getCapitalGainFromTo(priceToday, priceLast3Y);
//   const cap5Y = getCapitalGainFromTo(priceToday, priceLast5Y);

//   // console.log('cap1Y', cap1Y);
//   // console.log('cap3Y', cap3Y);
//   // console.log('cap5Y', cap5Y);
//   // const capitalGain = (cap1Y + (cap3Y / 3) + (cap5Y / 5)) / 3;

//   const realValues = _.compact([cap1Y, cap3Y/3, cap5Y/5]);
//   const capitalGain = _.sum(realValues) / _.size(realValues);
//   return Math.round(10000 * capitalGain) / 10000;
// }

export const getDisplayText = (key, value, checkNaN) => {
  // console.log("getDisplayText??", key, value);
  if (_.toNumber(value) === 0 || _.isNil(value) || _.isUndefined(value)) {
    return "N/A";
  } else if (checkNaN) {
    if (_.isNaN(value)) {
      return "N/A";
    }
  }
  return value;
};

export const getProjectStat = (project) => {
  // console.log('getProjectStat params&&', project)
  if (project) {
    const {
      developer,
      yearLaunch,
      yearComplete,
      station,
      distanceFromBts,
      totalUnits,
      parkingLot,
      projectType,
      floor,
      furniturePackage,
      ceiling,
      sinkingFund,
      commonFee,
      percentSold,
      unitsLeft,
      projectStatus,
      constructionStatus,
      absorptionRateAll,
      absorptionRateLastQ,
      startingResalePrice,
      resalePriceSqm,
      rentalPrice,
      rentalPriceSqm,
      capitalGain,
      rentalYield,
      launchPriceSqm,
      startingPrice,
      startingCurrentPrice,
      currentPriceSqm,
      rooms,
    } = project;
    // const { salePrice, rentalPrice, capitalGain, rentalYield } = current;

    return {
      developer: getDisplayText("developer", developer),
      yearLaunch: getDisplayText("yearLaunch", yearLaunch),
      yearComplete: getDisplayText("yearComplete", yearComplete),
      station: getDisplayText("station", _.get(station, "name")),
      distanceFromBts: getDisplayText("distanceFromBts", distanceFromBts),
      totalUnits: getDisplayText("totalUnits", totalUnits),
      parkingLot: getDisplayText("parkingLot", parkingLot),
      projectType: getDisplayText("projectType", projectType),
      floor: getDisplayText("floor", floor),
      furniturePackage: getDisplayText("furniturePackage", furniturePackage),
      ceiling: getDisplayText("ceiling", ceiling),
      sinkingFund: getDisplayText("sinkingFund", sinkingFund),
      commonFee: getDisplayText("commonFee", commonFee),
      percentSold: getDisplayText("percentSold", percentSold),
      unitsLeft: getDisplayText("unitsLeft", unitsLeft),
      projectStatus: getDisplayText("projectStatus", projectStatus),
      constructionStatus: getDisplayText(
        "constructionStatus",
        constructionStatus
      ),
      absorptionRateAll: getDisplayText("absorptionRateAll", absorptionRateAll),
      absorptionRateLastQ: getDisplayText(
        "absorptionRateLastQ",
        absorptionRateLastQ
      ),
      startingResalePrice: getDisplayText(
        "startingResalePrice",
        startingResalePrice
      ),
      resalePriceSqm: getDisplayText("resalePriceSqm", resalePriceSqm),
      rentalPrice: getDisplayText("rentalPrice", rentalPrice),
      rentalPriceSqm: getDisplayText("rentalPriceSqm", rentalPriceSqm),
      capitalGain: getDisplayText("capitalGain", capitalGain),
      rentalYield: getDisplayText("rentalYield", rentalYield),
      launchPriceSqm: getDisplayText("launchPriceSqm", launchPriceSqm),
      startingPrice: getDisplayText("startingPrice", startingPrice),
      startingCurrentPrice: getDisplayText(
        "startingCurrentPrice",
        startingCurrentPrice
      ),
      currentPriceSqm: getDisplayText("currentPriceSqm", currentPriceSqm),
      rooms,
    };
  }
  return {};
};

export const sanitizeKeyValues = (key, values) => {
  return _.map(
    _.filter(values, (value) => {
      // console.log('sanitizeKeyValues', key, value, value[key])
      if (value[key] === "N/A") return false;
      if (value[key] === 0) return false;
      if (_.isNaN(value[key])) return false;
      if (value[key] === Infinity) return false;
      return true;
    }),
    key
  );
};

const getMinStat = (key, useGlobalMin, avgObject, finalAvgStats) => {
  if (_.get(finalAvgStats, key, 0) === 0 && _.get(avgObject, key, 0) > 0) {
    return _.get(avgObject, key, 0);
  }
  if (useGlobalMin) {
    return _.toNumber(localStorage.getItem(`min_${key}` || "0"));
  } else if (
    _.get(avgObject, key, 0) === 0 ||
    _.get(finalAvgStats, key, 0) === 0
  ) {
    // console.log("both 0??");
    return 0;
  } else {
    // console.log(
    //   "min result??",
    //   _.min([_.get(finalAvgStats, key, 0), _.get(avgObject, key, 0)])
    // );

    return _.min([_.get(finalAvgStats, key, 0), _.get(avgObject, key, 0)]);
  }
};

export const calculateAvgProjectStats = (
  allProjectStats,
  useGlobalMin = false
) => {
  // console.log("allProjectStats??", allProjectStats);
  // const allProjectStatsSize = _.size(allProjectStats);
  let allProjectStatsSize = {};
  // console.log("allProjectStatsSize??", allProjectStatsSize);
  let finalAvgStats = {};
  _.map(allProjectStats, (a) => {
    const avgObject = getRoomDataForRender(_.get(a, "rooms"), [
      { key: "startingPrice", mode: "min" },
      { key: "startingResalePrice", mode: "min" },
      { key: "resalePriceSqm", mode: "avg" },
      { key: "rentalPriceSqm", mode: "avg" },
      { key: "totalUnits", mode: "sum" },
      { key: "soldUnits", mode: "sum" },
      { key: "unitsLeft", mode: "sum" },
      { key: "percentSold", mode: "avg" },
      { key: "rentalYield", mode: "avg" },
      { key: "capitalGain", mode: "avg" },
    ]);
    allProjectStatsSize = {
      ...allProjectStatsSize,
      startingPrice:
        _.get(avgObject, "startingPrice", 0) > 0
          ? _.get(allProjectStatsSize, "startingPrice", 0) + 1
          : _.get(allProjectStatsSize, "startingPrice", 0),
      startingResalePrice:
        _.get(avgObject, "startingResalePrice", 0) > 0
          ? _.get(allProjectStatsSize, "startingResalePrice", 0) + 1
          : _.get(allProjectStatsSize, "startingResalePrice", 0),
      resalePriceSqm:
        _.get(avgObject, "resalePriceSqm", 0) > 0
          ? _.get(allProjectStatsSize, "resalePriceSqm", 0) + 1
          : _.get(allProjectStatsSize, "resalePriceSqm", 0),
      rentalPriceSqm:
        _.get(avgObject, "rentalPriceSqm", 0) > 0
          ? _.get(allProjectStatsSize, "rentalPriceSqm", 0) + 1
          : _.get(allProjectStatsSize, "rentalPriceSqm", 0),
      totalUnits:
        _.get(avgObject, "totalUnits", 0) > 0
          ? _.get(allProjectStatsSize, "totalUnits", 0) + 1
          : _.get(allProjectStatsSize, "totalUnits", 0),
      soldUnits:
        _.get(avgObject, "soldUnits", 0) > 0
          ? _.get(allProjectStatsSize, "soldUnits", 0) + 1
          : _.get(allProjectStatsSize, "soldUnits", 0),
      unitsLeft:
        _.get(avgObject, "unitsLeft", 0) > 0
          ? _.get(allProjectStatsSize, "unitsLeft", 0) + 1
          : _.get(allProjectStatsSize, "unitsLeft", 0),
      percentSold:
        _.get(avgObject, "percentSold", 0) > 0
          ? _.get(allProjectStatsSize, "percentSold", 0) + 1
          : _.get(allProjectStatsSize, "percentSold", 0),
      rentalYield:
        _.get(avgObject, "rentalYield", 0) > 0
          ? _.get(allProjectStatsSize, "rentalYield", 0) + 1
          : _.get(allProjectStatsSize, "rentalYield", 0),
      capitalGain:
        _.get(avgObject, "capitalGain", 0) > 0
          ? _.get(allProjectStatsSize, "capitalGain", 0) + 1
          : _.get(allProjectStatsSize, "capitalGain", 0),
    };
    // console.log(`allProjectStatsSize??`, allProjectStatsSize);
    // console.log(`avgObject??`, avgObject);
    // console.log(
    //   `finalAvgStats startingPrice??`,
    //   _.get(finalAvgStats, "startingPrice", 0)
    // );
    // console.log(
    //   `avgObject startingPrice??`,
    //   _.get(avgObject, "startingPrice", 0)
    // );
    // console.log(
    //   `min startingPrice??`,
    //   _.min([
    //     _.get(finalAvgStats, "startingPrice", 0),
    //     _.get(avgObject, "startingPrice", 0),
    //   ])
    // );
    finalAvgStats = {
      startingPrice: getMinStat(
        "startingPrice",
        useGlobalMin,
        avgObject,
        finalAvgStats
      ),
      startingResalePrice: getMinStat(
        "startingResalePrice",
        useGlobalMin,
        avgObject,
        finalAvgStats
      ),
      resalePriceSqm:
        _.get(finalAvgStats, "resalePriceSqm", 0) +
        _.get(avgObject, "resalePriceSqm", 0),
      rentalPriceSqm:
        _.get(finalAvgStats, "rentalPriceSqm", 0) +
        _.get(avgObject, "rentalPriceSqm", 0),
      totalUnits:
        _.get(finalAvgStats, "totalUnits", 0) +
        _.get(avgObject, "totalUnits", 0),
      soldUnits:
        _.get(finalAvgStats, "soldUnits", 0) + _.get(avgObject, "soldUnits", 0),
      unitsLeft:
        _.get(finalAvgStats, "unitsLeft", 0) + _.get(avgObject, "unitsLeft", 0),
      percentSold:
        _.get(finalAvgStats, "percentSold", 0) +
        _.get(avgObject, "percentSold", 0),
      rentalYield:
        _.get(finalAvgStats, "rentalYield", 0) +
        _.get(avgObject, "rentalYield", 0),
      capitalGain:
        _.get(finalAvgStats, "capitalGain", 0) +
        _.get(avgObject, "capitalGain", 0),
    };
    // console.log("finalAvgStats??", finalAvgStats);
  });
  // console.log(
  //   "last finalAvgStats startingPrice??",
  //   _.get(finalAvgStats, "startingPrice", 0)
  // );

  finalAvgStats = {
    startingPrice: useGlobalMin
      ? _.toNumber(localStorage.getItem(`min_startingPrice` || "0"))
      : _.get(finalAvgStats, "startingPrice", 0),
    startingResalePrice: useGlobalMin
      ? _.toNumber(localStorage.getItem(`min_startingResalePrice` || "0"))
      : _.get(finalAvgStats, "startingResalePrice", 0),
    resalePriceSqm:
      _.get(finalAvgStats, "resalePriceSqm", 0) /
      _.get(allProjectStatsSize, "resalePriceSqm"),
    rentalPriceSqm:
      _.get(finalAvgStats, "rentalPriceSqm", 0) /
      _.get(allProjectStatsSize, "rentalPriceSqm"),
    totalUnits: _.get(finalAvgStats, "totalUnits", 0),
    soldUnits: _.get(finalAvgStats, "soldUnits", 0),
    unitsLeft: _.get(finalAvgStats, "unitsLeft", 0),
    percentSold:
      _.get(finalAvgStats, "percentSold", 0) /
      _.get(allProjectStatsSize, "percentSold"),
    rentalYield:
      _.get(finalAvgStats, "rentalYield", 0) /
      _.get(allProjectStatsSize, "rentalYield"),
    capitalGain:
      _.get(finalAvgStats, "capitalGain", 0) /
      _.get(allProjectStatsSize, "capitalGain"),
  };
  // console.log(
  //   "last 2 finalAvgStats startingPrice??",
  //   _.get(finalAvgStats, "startingPrice", 0)
  // );

  const absorptionRateAllValues = sanitizeKeyValues(
    "absorptionRateAll",
    allProjectStats
  );
  const absorptionRateLastQValues = sanitizeKeyValues(
    "absorptionRateLastQ",
    allProjectStats
  );
  const estimateTimeToDairnValues = sanitizeKeyValues(
    "estimateTimeToDairn",
    allProjectStats
  );
  const rentalPriceValues = sanitizeKeyValues("rentalPrice", allProjectStats);
  const launchPriceSqmValues = sanitizeKeyValues(
    "launchPriceSqm",
    allProjectStats
  );
  const startingCurrentPriceValues = sanitizeKeyValues(
    "startingCurrentPrice",
    allProjectStats
  );
  const currentPriceSqmValues = sanitizeKeyValues(
    "currentPriceSqm",
    allProjectStats
  );
  // const percentSoldValues = sanitizeKeyValues('percentSold', allProjectStats);
  const avg = {
    // salePrice: _.sum(salePriceValues) / _.size(salePriceValues),
    resalePriceSqm: getDisplayText(
      "resalePriceSqm",
      _.get(finalAvgStats, "resalePriceSqm"),
      true
    ),
    capitalGain: getDisplayText(
      "capitalGain",
      _.get(finalAvgStats, "capitalGain"),
      true
    ),
    startingPrice: getDisplayText(
      "startingPrice",
      useGlobalMin
        ? _.toNumber(localStorage.getItem(`min_startingPrice` || "0"))
        : _.get(finalAvgStats, "startingPrice", 0),
      true
    ),
    startingResalePrice: getDisplayText(
      "startingResalePrice",
      useGlobalMin
        ? _.toNumber(localStorage.getItem(`min_startingResalePrice` || "0"))
        : _.get(finalAvgStats, "startingResalePrice", 0),
      true
    ),
    rentalPriceSqm: getDisplayText(
      "rentalPriceSqm",
      _.get(finalAvgStats, "rentalPriceSqm"),
      true
    ),
    rentalYield: getDisplayText(
      "rentalYield",
      _.get(finalAvgStats, "rentalYield"),
      true
    ),
    percentSold: getDisplayText(
      "percentSold",
      _.get(finalAvgStats, "percentSold"),
      true
    ),
    unitsLeft: getDisplayText(
      "unitsLeft",
      _.get(finalAvgStats, "unitsLeft"),
      true
    ),

    absorptionRateAll: getDisplayText(
      "absorptionRateAll",
      _.sum(absorptionRateAllValues) / _.size(absorptionRateAllValues),
      true
    ),
    absorptionRateLastQ: getDisplayText(
      "absorptionRateLastQ",
      _.sum(absorptionRateLastQValues) / _.size(absorptionRateLastQValues),
      true
    ),
    estimateTimeToDairn: getDisplayText(
      "estimateTimeToDairn",
      _.sum(estimateTimeToDairnValues) / _.size(estimateTimeToDairnValues),
      true
    ),
    rentalPrice: getDisplayText(
      "rentalPrice",
      _.sum(rentalPriceValues) / _.size(rentalPriceValues),
      true
    ),
    launchPriceSqm: getDisplayText(
      "launchPriceSqm",
      _.sum(launchPriceSqmValues) / _.size(launchPriceSqmValues),
      true
    ),
    startingCurrentPrice: getDisplayText(
      "startingCurrentPrice",
      _.sum(startingCurrentPriceValues) / _.size(startingCurrentPriceValues),
      true
    ),
    currentPriceSqm: getDisplayText(
      "currentPriceSqm",
      _.sum(currentPriceSqmValues) / _.size(currentPriceSqmValues),
      true
    ),
  };
  // console.log("last 3 avg startingPrice??", _.get(avg, "startingPrice", 0));

  return avg;
};

export const getRoomDataForRender = (rooms, keys) => {
  let resultObj = {};
  let minObj = {};
  let roomCount = {};
  _.map(rooms, (i, rt) => {
    _.map(i, (j, rs) => {
      _.map(keys, (k) => {
        const key = _.get(k, "key");
        const keyValue = _.get(j, key, 0);
        // console.log("key??", key);
        // console.log("keyValue??", keyValue);

        let tmpMin = 0;
        if (keyValue > 0) {
          roomCount = {
            ...roomCount,
            [key]: _.get(roomCount, key, 0) + 1,
          };
          resultObj = {
            ...resultObj,
            [key]: _.get(resultObj, key, 0) + keyValue,
          };
          tmpMin = keyValue;
        }
        // if (key === "startingPrice") {
        //   console.log("tmpMin??", tmpMin);
        // }
        if (tmpMin > 0) {
          // Personal min value
          if (_.get(minObj, key, 0) === 0) {
            minObj = {
              ...minObj,
              [key]: tmpMin,
            };
          } else {
            tmpMin =
              tmpMin < _.get(minObj, key, 0) ? tmpMin : _.get(minObj, key, 0);
          }
          minObj = {
            ...minObj,
            [key]: tmpMin,
          };
          // if (key === "startingPrice") {
          //   console.log("minObj??", minObj);
          // }
          // console.log(
          //   `min_${key} bf`,
          //   localStorage.getItem(`min_${key}` || "0")
          // );
          // console.log(
          //   `min_${key} num bf`,
          //   _.toNumber(localStorage.getItem(`min_${key}` || "0"))
          // );

          // Global min value
          if (_.toNumber(localStorage.getItem(`min_${key}` || "0")) === 0) {
            localStorage.setItem(`min_${key}`, tmpMin);
          } else {
            tmpMin =
              tmpMin < _.toNumber(localStorage.getItem(`min_${key}` || "0"))
                ? tmpMin
                : _.toNumber(localStorage.getItem(`min_${key}` || "0"));
          }
          localStorage.setItem(`min_${key}`, tmpMin);

          // console.log(
          //   `min_${key} af`,
          //   localStorage.getItem(`min_${key}` || "0")
          // );
        }
      });
    });
  });
  _.map(resultObj, (item, i) => {
    if (i !== "count") {
      const keyData = _.find(keys, (k) => _.get(k, "key") === i);
      switch (_.get(keyData, "mode")) {
        case "avg":
          resultObj = {
            ...resultObj,
            [i]: item / _.get(roomCount, i, 0),
          };
          break;
        case "min":
          // console.log("i??", i);
          // console.log("minValue??", _.get(minObj, i, 0));
          // console.log(
          //   "minValue??",
          //   _.toNumber(localStorage.getItem(`min_${i}` || "0"))
          // );
          resultObj = {
            ...resultObj,
            [i]: _.get(minObj, i, 0),
          };
          break;
        default:
          break;
      }
    }
  });
  // console.log("last resultObj??", resultObj);
  return resultObj;
};



// WEBPACK FOOTER //
// ./src/utils/stat-utils.js